var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.448 2.808a3.236 3.236 0 0 0-.812-1.435 3.127 3.127 0 0 0-1.4-.831C20.295 0 12.486 0 12.486 0S4.68.016 2.74.558a3.126 3.126 0 0 0-1.402.831 3.237 3.237 0 0 0-.81 1.435c-.588 3.53-.815 8.908.015 12.297.144.543.423 1.037.812 1.435.388.397.87.684 1.4.83 1.94.543 9.75.543 9.75.543s7.807 0 9.747-.542a3.127 3.127 0 0 0 1.401-.831c.389-.398.668-.892.812-1.435.619-3.535.81-8.91-.016-12.313Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.002 12.806 6.477-3.842-6.477-3.842v7.684Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v18H0z"
  })))));
};

export default SvgYoutube;